/* CF2 ACCENT-SCALE LAW tagger (layout, NOT motion-gated — must run for
   reduced-motion users too, so it lives OUTSIDE the .dor-anim-on gate below).
   Long script accents (3+ words or >=12 chars) get .dor-uword--long; the CF2
   block in dorellini-brand.css scales them to the reference ratio (1.06em).
   Sacred S&S selector excluded. */
(function () {
  try {
    document.querySelectorAll('.dor-uword > em, .dor-uword > .dorellini-script').forEach(function (em) {
      var t = em.textContent.trim();
      if ((t.split(/\s+/).length >= 3 || t.length >= 12) && !em.closest('.dor-ss2-sel')) {
        em.parentElement.classList.add('dor-uword--long');
      }
    });
  } catch (e) { /* graceful: accents keep their section scale */ }
})();

/**
 * Dorellini scroll-triggered fade-up reveal
 *
 * Pairs with the inline <script> in theme.liquid <head> that adds
 * .dor-anim-on to <html> ONLY when IntersectionObserver is supported
 * AND user does NOT prefer reduced motion. So when this script runs,
 * .dor-anim-on is already in place (or absent → content stays visible).
 *
 * Reveal CSS targets brand classes directly (.dorellini-section,
 * .dor-card, .dor-pillar, .dor-review, .dor-claims__chip, .dor-faq).
 * This script:
 *   1. Sets staggered transition-delay on grouped child elements
 *      (cards, pillars, reviews, faqs, chips).
 *   2. Observes every target and adds .is-dor-revealed on intersection.
 *   3. Safety net: reveals everything after 2 s if any element is still
 *      stranded — content can never stay invisible.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (!document.documentElement.classList.contains('dor-anim-on')) return;

  var SELECTOR =
    '.dorellini-section, .dor-card, .dor-pillar, .dor-review, .dor-claims__chip, .dor-faq, .dor-pdp-flavor-opt, .dor-rv';
  var STAGGER_MS = 90;
  var STAGGER_GROUP_SELECTOR =
    '.dor-card, .dor-pillar, .dor-review, .dor-claims__chip, .dor-faq, .dor-pdp-flavor-opt, .dor-rv';

  function applyStagger(root) {
    // For each parent that contains stagger-group children, set transition-delay per child.
    // _dorIndex on the parent persists across children of the same parent.
    root.querySelectorAll(STAGGER_GROUP_SELECTOR).forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      if (typeof parent._dorIndex !== 'number') {
        parent._dorIndex = 0;
      }
      el.style.transitionDelay = parent._dorIndex * STAGGER_MS + 'ms';
      parent._dorIndex += 1;
    });
  }

  function reveal(el) {
    if (!el.classList.contains('is-dor-revealed')) {
      el.classList.add('is-dor-revealed');
    }
  }

  function init() {
    applyStagger(document);

    var targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    if (typeof IntersectionObserver !== 'function') {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });

    // Safety net: reveal anything still stranded after 2 s.
    setTimeout(function () {
      document.querySelectorAll(SELECTOR + ':not(.is-dor-revealed)').forEach(reveal);
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after a Theme Editor section load injects new DOM.
  document.addEventListener('shopify:section:load', function (event) {
    var newRoot = event && event.target ? event.target : document;
    applyStagger(newRoot);
    var targets = newRoot.querySelectorAll(SELECTOR);
    targets.forEach(reveal);
  });
})();
